module.exports = __webpack_public_path__ + "img/unreal.d9892951.svg";